<!-- 路线页 -->
<template>
  <div class="route">
    <!-- 头部 -->
    <div class="topDet">
      <router-link to="/route" class="topLeft">
        <div class="backIcon">
          <img src="./image/icon_back.svg" alt="" />
        </div>
        <div class="backText">返回</div>
      </router-link>
      <div class="topTitle">路线详情</div>
    </div>
    <!-- 底部详情 -->
    <div class="bottomDet" v-show="bottomShow">
      <div class="bottomTop" @click="bottomtopFn()">
        <div class="topIcon"></div>
      </div>
      <div class="bottomCon">
        <div class="conName">
          路线名称路线名称路线名称路线名称路线名称路线名称
        </div>
        <div class="conLine">
          <div class="lineCon">
            <div class="startMarker">
              <div class="start"></div>
              <div class="startName">银杏天鹅湖</div>
            </div>
            <div class="toIcon"></div>
            <div class="endMarker">
              <div class="end"></div>
              <div class="endName">银杏天鹅湖</div>
            </div>
          </div>
          <div class="lineDetail">
            <div class="detLeft">
              全路线有<span class="detTT">6</span>个景点
            </div>
            <div class="detLeft">
              大约需要<span class="detTT">02</span>小时<span class="detTT"
                >50</span
              >分钟
            </div>
          </div>
        </div>
        <div class="lineIntro">路线介绍</div>
      </div>
      <div class="bottomIntro" v-show="bottomIntro">
        <div class="introImg">
          <div class="allList">
            <div class="imgList"></div>
          </div>
        </div>
        <div class="introText">
          银杏天鹅湖，位于浙江省嘉兴市秀洲区油车港镇，东邻上海，西靠杭州，南涉杭州湾，北接苏州，交通十分便捷。项目由华章文旅集团旗下的嘉兴灵粮生态农业有限公司全力打造，是一个集生态与自然和谐共生、智慧与科技共存、艺术与人文相互交融的文化旅游综合体。项目一期总面积约2120亩，其中水域面积达1000多亩，水域清澈见底，已接近Ⅱ类水标准。
        </div>
        <div class="toStart">
          <div class="startBtn" @click="startBtnFn()">
            开始游玩
            <span class="startIcon">></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      bottomIntro: false, //底部详情的显示
      bottomShow: true, //底部的显示与隐藏
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //显示底部简介内容
    bottomtopFn() {
      if (!this.bottomIntro) {
        this.bottomIntro = true;
      } else {
        this.bottomIntro = false;
      }
    },
    //开始游玩
    startBtnFn() {
      this.bottomShow = false;
      console.log(111);
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="less">
.route {
  width: 100%;
  height: 100vh;
  position: relative;
  .topDet {
    width: 100%;
    height: 4.8rem;
    position: absolute;
    top: 0;
    padding: 1.3rem 1.8rem;
    border-bottom: 0.1rem solid #eee;
    display: flex;
    background: #fafafa;
    .topLeft {
      width: 5rem;
      height: 2.2rem;
      display: flex;
      align-items: center;
      float: left;
      .backIcon {
        width: 2rem;
        height: 2rem;
      }
      .backText {
        width: 2.8rem;
        height: 2rem;
        font-size: 1.4rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #333333;
        line-height: 2rem;
      }
    }
    .topTitle {
      width: 7.2rem;
      height: 2.2rem;
      font-size: 1.6rem;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #333333;
      line-height: 2.2rem;
      letter-spacing: 0rem;
      position: absolute;
      left: 50%;
      margin-left: -3.6rem;
    }
  }
  .bottomDet {
    width: 100%;
    background: #fafafa;
    border-radius: 1.2rem 1.2rem 0rem 0rem;
    position: absolute;
    bottom: 0;
    .bottomTop {
      width: 100%;
      height: 3.2rem;
      margin-bottom: 0.8rem;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      .topIcon {
        width: 6.4rem;
        height: 0.5rem;
        background: #cfcfcf;
        border-radius: 0.3rem;
      }
    }
    .bottomCon {
      width: 100%;
      height: 15.8rem;
      padding: 0 1.75rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .conName {
        width: 100%;
        height: 2.5rem;
        font-size: 1.8rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 2.5rem;
        letter-spacing: 0rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      .conLine {
        width: 100%;
        height: 7.8rem;
        background: #ffcd6c;
        border-radius: 0.8rem;
        padding: 1.2rem 1.6rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .lineCon {
          width: 100%;
          height: 2.2rem;
          display: flex;
          align-items: center;
          .startMarker {
            height: 2.2rem;
            display: flex;
            align-items: center;
            .start {
              width: 0.6rem;
              height: 0.6rem;
              background: #4d7eff;
              border-radius: 50%;
              margin-right: 0.6rem;
            }
            .startName {
              height: 2.2rem;
              font-size: 1.6rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              line-height: 2.2rem;
              letter-spacing: 0rem;
            }
          }
          .toIcon {
            width: 1.6rem;
            height: 0.5rem;
            background: url("./image/to2.svg") no-repeat;
            background-size: 100%;
            margin: 0 1rem;
          }
          .endMarker {
            height: 2.2rem;
            display: flex;
            align-items: center;
            .end {
              width: 0.6rem;
              height: 0.6rem;
              background: #44da89;
              border-radius: 50%;
              margin-right: 0.6rem;
            }
            .endName {
              height: 2.2rem;
              font-size: 1.6rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              line-height: 2.2rem;
              letter-spacing: 0rem;
            }
          }
        }
        .lineDetail {
          width: 100%;
          height: 2rem;
          display: flex;
          justify-content: space-between;
          .detLeft {
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: #766648;
            line-height: 2rem;
            letter-spacing: 0rem;
            .detTT {
              height: 2rem;
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              line-height: 2rem;
              letter-spacing: 0rem;
            }
          }
        }
      }
      .lineIntro {
        width: 7.2rem;
        height: 2.5rem;
        font-size: 1.8rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 1.8rem;
      }
    }
    .bottomIntro {
      width: 100%;
      height: 35.1rem;
      padding: 1.6rem 1.6rem 0;
      .introImg {
        width: 100%;
        height: 10.8rem;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        .allList {
          height: 10.8rem;
          .imgList {
            width: 10.8rem;
            height: 10.8rem;
            border-radius: 0.4rem;
            background: #44da89;
            margin: 0 0.3rem;
            display: inline-block;
          }
        }
      }
      .introText {
        width: 100%;
        height: 16.8rem;
        margin-top: 1.6rem;
        overflow: auto;
        font-size: 1.4rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #666666;
        line-height: 2.4rem;
      }
      .toStart {
        width: 100%;
        height: 4.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .startBtn {
          width: 9rem;
          height: 2.2rem;
          font-size: 1.6rem;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: CENTER;
          color: #333333;
          line-height: 2.2rem;
          .startIcon {
            width: 1.6rem;
            height: 1.6rem;
            border-radius: 50%;
            display: inline-block;
            border: 0.1rem solid #ffcd6c;
            text-align: center;
            line-height: 1.1rem;
          }
        }
      }
    }
  }
}
</style>